module.exports = __webpack_public_path__ + "img/background023.cac86dea.jpg";